import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props } from './componentEl-c8b73b10.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-7e57ffb0.js';

/**
This is a simple Circular Loader
*/
function Loader({
  componentEl: Component,
  margin,
  size,
  className,
  ...otherProps
}) {
  let cssClasses = ['st_loader', `st_loader--${size}`];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps));
}
Loader.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** size of loader */
  size: PropTypes.oneOf(['md', 'lg', 'xl'])
};
Loader.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  size: 'xl'
};

export { Loader as L };
